import config from '@/config.js'
import http from '@/utils/http.js'
import cognito from '@/utils/cognito.js'

export default {
  login ({ commit }, { username, password }) {
    return new Promise((resolve, reject) => {
      cognito.login(username, password)
      .then(response => {
        const JwtToken = response.getIdToken().getJwtToken()
        const RefreshToken = response.getRefreshToken().getToken()
        if (JwtToken && RefreshToken) {
          commit('SET_TOKEN', JwtToken)
          commit('SET_REFRESHTOKEN', RefreshToken)
          if (window.localStorage) {
            window.localStorage.setItem('token', JwtToken)
            window.localStorage.setItem('refreshToken', RefreshToken)
          }
          resolve()
          return
        }
        reject('Cannot retrieve token')
      })
      .catch(error => reject(error))
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_USER', null)
      commit('SET_TOKEN', null)
      commit('SET_REFRESHTOKEN', null)
      commit('SET_SETTINGPARAMS', null)

      if (window.localStorage) {
        window.localStorage.setItem('user', null)
        window.localStorage.setItem('token', null)
        window.localStorage.setItem('refreshToken', null)
        window.localStorage.setItem('settingParams', null)
      }
      // cognito.logout() // TODO:これちゃんと動いてない、、、、
      resolve()
    })
  },
  getme ({ commit }) {
    return new Promise((resolve, reject) => {
      http.request('get', '/service2/dashboard/api/accounts/getDetail')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            console.log(data.result)
            reject('get account data failed (get me). (' + data.result + ')')
          }

          commit('SET_USER', data)

          if (window.localStorage) {
            window.localStorage.setItem('user', JSON.stringify(data))
          }
          resolve()
        })
    })
  },
  getSettingParam ({ commit }) {
    return new Promise((resolve, reject) => {
      http.request('get', '/service2/dashboard/api/accounts/getSettingModalParams')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            reject('get setting param failed. (' + data.result + ')')
          }

          if (data.settingModalParam === null) {
            data.settingModalParam = config.defaultSettingParams
          } else {
            // 不足項目を確認して埋める
            for (var key in config.defaultSettingParams) {
              if (!data.settingModalParam[key]) {
                data.settingModalParam[key] = config.defaultSettingParams[key]
              }
            }
          }

          commit('SET_SETTINGPARAMS', data.settingModalParam)

          if (window.localStorage) {
            window.localStorage.setItem('settingParams', JSON.stringify(data.settingModalParam))
          }

          resolve()
        })
    })
  },
  setSettingParam ({ commit }, { unit, timezone, pressureUnit, temperatureUnit, emailNotification, emailLanguage }) {
    return new Promise((resolve, reject) => {
      if (!unit) {
        unit = this.getters.settingParams.unit
      }
      if (!timezone) {
        timezone = this.getters.settingParams.timezone
      }
      if (!pressureUnit) {
        pressureUnit = this.getters.settingParams.pressureUnit
      }
      if (!temperatureUnit) {
        temperatureUnit = this.getters.settingParams.temperatureUnit
      }
      if (!emailNotification) {
        emailNotification = this.getters.settingParams.emailNotification
      }
      if (!emailLanguage) {
        emailLanguage = this.getters.settingParams.emailLanguage
      }
      const params = {
        settingModalParam: {
          unit: unit,
          timezone: timezone,
          pressureUnit: pressureUnit,
          temperatureUnit: temperatureUnit,
          emailNotification: emailNotification,
          emailLanguage: emailLanguage
        }
      }
      http.request('post', '/service2/dashboard/api/Accounts/updateSettingModalParams', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            reject('set setting param failed. (' + data.result + ')')
          }

          commit('SET_SETTINGPARAMS', params.settingModalParam)

          if (window.localStorage) {
            window.localStorage.setItem('settingParams', JSON.stringify(params.settingModalParam))
          }

          resolve()
        })
    })
  },
  setShowStartGuide ({ commit }, flag) {
    return new Promise((resolve, reject) => {
      commit('SET_SHOWSTARTGUIDE', flag)

      if (window.localStorage) {
        window.localStorage.setItem('showStartGuide', JSON.stringify({showStartGuide: flag}))
      }
    })
  },
  setLanguage ({ commit }, flag) {
    return new Promise((resolve, reject) => {
      if (window.localStorage) {
        window.localStorage.setItem('language', JSON.stringify({language: flag}))
      }
      location.reload()
    })
  },
  refreshSession ({ commit }, {username, refreshToken}) {
    console.log(username)
    console.log(refreshToken)
    return new Promise((resolve, reject) => {
      cognito.refreshSession(username, refreshToken)
      .then(response => {
        const JwtToken = response.getIdToken().getJwtToken()
        const RefreshToken = response.getRefreshToken().getToken()
        if (JwtToken && RefreshToken) {
          commit('SET_TOKEN', JwtToken)
          commit('SET_REFRESHTOKEN', RefreshToken)
          if (window.localStorage) {
            window.localStorage.setItem('token', JwtToken)
            window.localStorage.setItem('refreshToken', RefreshToken)
          }
          resolve(response)
          return
        }
        reject('refreshSession: err: JwtToken || RefreshToken does not exist')
      })
      .catch(error => {
        console.log(error)
        reject('RefreshSession is Error')
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js